import { get, post } from 'lib/request';

export const getUserEmailPreferences = async (opts) =>
  get('/user/mail/permissions', opts);

export const getUserWebpushPreferences = async (opts) =>
  get('/user/webpush/permissions', opts);

export const postUserEmailPreference = async ({ action, permission }) =>
  post('/user/mail/change-permission', {
    body: { action, mailTemplate: permission },
  });

export const postUserWebpushPreference = async ({ action, permission }) =>
  post('/user/webpush/change-permission', {
    body: { action, webpushTemplate: permission },
  });
